module.exports = __webpack_public_path__ + "img/login-v3.2f0d90e8.png";